const MAX_LENGTH_SNOWPLOW_STRING = 200;

export const truncateDataToMaxLength = (data?: string): string | undefined => {
  return data?.substring(0, MAX_LENGTH_SNOWPLOW_STRING);
};
